import { render, staticRenderFns } from "./NoticeContainer.vue?vue&type=template&id=d615bc68&"
import script from "./NoticeContainer.vue?vue&type=script&lang=js&"
export * from "./NoticeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports